import { createSlice } from '@reduxjs/toolkit';

import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  error: false
};

const slice = createSlice({
  name: 'mail',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    }
  }
});

// Reducer
export default slice.reducer;

export function sendConfirmEmail({ callback, error, form }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.post('/sendConfirmEmail', {
        userId: error.user.id,
        email: form.email
      });
      if (result) {
        callback(result);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
